import { createFileRoute } from "@tanstack/react-router";
import { TravelDetailPage } from "../../components/participant/travel-detail-page";

/** `/me/travel/:acCardId/:direction` (arrival | departure) — one of the participant's own legs, whole. Reads `/me/travel` (keyed on the login), so another person's card is simply not found. */
export const Route = createFileRoute("/_app/me/travel/$acCardId/$direction")({
	component: function TravelDetailRoute() {
		const { acCardId, direction } = Route.useParams();
		return <TravelDetailPage acCardId={acCardId} direction={direction} />;
	},
});
